import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';
import {Button} from '@guestapp/ui';

export const Wrapper = styled.div`
  padding: 40px 24px;
  @media (min-width: ${device.tablet}) {
    padding: 24px 24px 0;
  }
`;

export const Container = styled.div`
  max-width: 522px;
  margin: 0 auto;

  & .box-info {
    max-width: 327px;
    margin: 0 auto;
    margin-bottom: 24px;
  }
`;

export const StyledButton = styled(Button)`
  width: 100%;
  max-width: 327px;
  margin: 0 auto;
`;
